import React, { useState } from "react";

import RowWrapper from "../../shared/bootstrap/RowWrapper.jsx";
import Panel from "../../shared/bootstrap/Panel.jsx";
import ContractDocuments from "../../shared/ContractDocuments.jsx";

import { MAX_NUM_DOCS_DISPLAY } from "../../../constants.js";

export default function Contract({ contract }) {
  const [showAllDocuments, setShowAllDocuments] = useState(false);
  const toggleShowAllDocuments = () => setShowAllDocuments((prevState) => !prevState);

  return (
    <div className="panel contract-display">
      <div className="panel-body">
        <RowWrapper>
          <div className="col-sm-5">
            <RowWrapper>
              <div className="col-md-12">
                Contract Number: <strong>{contract.sewpContractNumber}</strong>
              </div>
            </RowWrapper>
            <RowWrapper>
              <div className="col-md-12">
                Group: <strong>{contract.group}</strong>
              </div>
            </RowWrapper>
            <RowWrapper>
              <div className="col-md-12">
                NAICS: <strong>{contract.naicsCode}</strong>
              </div>
            </RowWrapper>
          </div>
          <div className="col-sm-7">
            <RowWrapper>
              <div className="col-md-6">Business Designation(s):</div>
              <div className="col-md-6">
                {contract.businessSizes.map(({ description, displayName }) => (
                  <RowWrapper key={displayName}>
                    {(contract.businessSizes.length === 1 ||
                      (contract.businessSizes.length > 1 && description !== "Small Business")) && (
                      <div className="col-md-12" title={displayName}>
                        <strong>{displayName}</strong>
                      </div>
                    )}
                  </RowWrapper>
                ))}
              </div>
            </RowWrapper>
          </div>
        </RowWrapper>
        <Panel>
          <div className="panel-heading">
            <strong>Contract Document(s):&nbsp;&nbsp;</strong>
            {contract.contractDocuments.length > MAX_NUM_DOCS_DISPLAY && (
              <small>
                <span className="showAll">
                  {showAllDocuments ? (
                    <a
                      role="button"
                      aria-label="Select to show original and latest contract documents"
                      onClick={toggleShowAllDocuments}
                    >
                      Show Fewer Contract Documents
                    </a>
                  ) : (
                    <a
                      role="button"
                      aria-label="Select to show all contract documents"
                      onClick={toggleShowAllDocuments}
                    >
                      Show All Contract Documents
                    </a>
                  )}
                </span>
              </small>
            )}
          </div>
          <ContractDocuments showAllDocuments={showAllDocuments} documents={contract.contractDocuments} />
        </Panel>
      </div>
    </div>
  );
}
